import { createReducer, on } from "@ngrx/store";
import { InitialNavbarState } from "./navbar.state";
import { ThemeActions } from "./navbar.actions";

export const ThemeReducer = createReducer(InitialNavbarState,
  on(ThemeActions.toggleTheme, (state, data) => ({ ...state, ...data }))
)